// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rct-node-icon {
  color: var(--usabt-blue-dark) !important;
}

#question-catalog-tree {
  border: 1px solid var(--grey3);
  max-height: 25rem;
  overflow-y: scroll;

}

#question-catalog-tree .rct-text {
    border-bottom: 1px solid lightgray;
    padding: 1px 0 1px 0;
  }

#question-catalog-tree .catalog-tree-icon-status,#question-catalog-tree .catalog-tree-parent-icon-status {
    display: inline;
  }

@media (max-width: 48rem) {

    #question-catalog-tree .react-checkbox-tree {
      flex-direction:  column;
    }
  }

#question-catalog-tree .react-checkbox-tree > ol > li > span .rct-node-icon .fa-circle {
    display: none;
  }

#question-catalog-tree .rct-node-leaf.empty .fa-circle {
      color: var(--grey3);
    }

#question-catalog-tree .rct-node-leaf.bad .fa-circle{
      color: var(--red3);
    }

#question-catalog-tree .rct-node-leaf.ok .fa-circle{
      color: var(--orange3);
    }

#question-catalog-tree .rct-node-leaf.good .fa-circle{
      color: var(--green2);
    }

#question-catalog-tree .rct-node-leaf .fa-circle {
      margin-left: 1px;
    }

#question-catalog-tree .rct-node-parent.empty > span .fa-circle {
      color: var(--grey3);
    }

#question-catalog-tree .rct-node-parent.bad > span .fa-circle{
      color: var(--red3);
    }

#question-catalog-tree .rct-node-parent.ok > span .fa-circle{
      color: var(--orange3);
    }

#question-catalog-tree .rct-node-parent.good > span .fa-circle{
      color: var(--green2);
    }

#question-catalog-tree .rct-node-parent .fa-circle {
      margin-left: 1px;
    }

#question-catalog-tree.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuestionCatalogTree.css"],"names":[],"mappings":"AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;;AAkEpB;;AAhEE;IACE,kCAAkC;IAClC,oBAAoB;EACtB;;AAEA;IACE,eAAe;EACjB;;AAEA;;IAEE;MACE,uBAAuB;IACzB;EACF;;AAEA;IACE,aAAa;EACf;;AAGE;MACE,mBAAmB;IACrB;;AAEA;MACE,kBAAkB;IACpB;;AAEA;MACE,qBAAqB;IACvB;;AAEA;MACE,oBAAoB;IACtB;;AAEA;MACE,gBAAgB;IAClB;;AAIA;MACE,mBAAmB;IACrB;;AAEA;MACE,kBAAkB;IACpB;;AAEA;MACE,qBAAqB;IACvB;;AAEA;MACE,oBAAoB;IACtB;;AAEA;MACE,gBAAgB;IAClB;;AAKJ;EACE,aAAa;AACf","sourcesContent":["@import \"../shared.css\";\r\n\r\n.rct-node-icon {\r\n  color: var(--usabt-blue-dark) !important;\r\n}\r\n\r\n#question-catalog-tree {\r\n  border: 1px solid var(--grey3);\r\n  max-height: 25rem;\r\n  overflow-y: scroll;\r\n\r\n  .rct-text {\r\n    border-bottom: 1px solid lightgray;\r\n    padding: 1px 0 1px 0;\r\n  }\r\n\r\n  .catalog-tree-icon-status, .catalog-tree-parent-icon-status {\r\n    display: inline;\r\n  }\r\n\r\n  @media (max-width: 48rem) {\r\n\r\n    .react-checkbox-tree {\r\n      flex-direction:  column;\r\n    }\r\n  }\r\n\r\n  .react-checkbox-tree>ol>li>span .rct-node-icon .fa-circle {\r\n    display: none;\r\n  }\r\n\r\n  .rct-node-leaf {\r\n    &.empty .fa-circle {\r\n      color: var(--grey3);\r\n    }\r\n\r\n    &.bad .fa-circle{\r\n      color: var(--red3);\r\n    }\r\n\r\n    &.ok .fa-circle{\r\n      color: var(--orange3);\r\n    }\r\n\r\n    &.good .fa-circle{\r\n      color: var(--green2);\r\n    }\r\n\r\n    .fa-circle {\r\n      margin-left: 1px;\r\n    }\r\n  }\r\n\r\n  .rct-node-parent {\r\n    &.empty>span .fa-circle {\r\n      color: var(--grey3);\r\n    }\r\n\r\n    &.bad>span .fa-circle{\r\n      color: var(--red3);\r\n    }\r\n\r\n    &.ok>span .fa-circle{\r\n      color: var(--orange3);\r\n    }\r\n\r\n    &.good>span .fa-circle{\r\n      color: var(--green2);\r\n    }\r\n\r\n    .fa-circle {\r\n      margin-left: 1px;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n#question-catalog-tree.hidden {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
